export const GET_CHARTING_SCREEN_SHOT = 'GET_CHARTING_SCREEN_SHOT';
export const CHARTING_SCREEN_SHOT_READY = 'CHARTING_SCREEN_SHOT_READY';
export const SESSION_TIME_OUT = 'SESSION_TIME_OUT';
export const API_TIMEOUT = 'ECONNABORTED ';
export const LOAD_WORKSPACE = 'LOAD_WORKSPACE';
export const SET_ERROR = 'SET_ERROR';

export const SYNC_COMPONENT_SEARCH = 'SYNC_COMPONENT_SEARCH';

export const TICKER_ADDED_TO_WL = 'TICKER_ADDED_TO_WL';
export const SHOULD_CALC_SIZE = 'SHOULD_CALC_SIZE';

export const SHOW_GUEST_POPUP = 'SHOW_GUEST_POPUP';

export const ON_TAB_FOCUS_BLUR = 'ON_TAB_FOCUS_BLUR';

class EventEmitter {
  events = {};

  dispatch = (event, data) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].forEach(callback => {
      callback(data);
    });
  };

  subscribe = (event, callback) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  };

  unsubscribe = (event, callback) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event] = this.events[event].filter(func => func !== callback);
  };
}

export default new EventEmitter();
